import React, { Component } from 'react';
import { Col, Row } from "antd";
import '../components-style.css';
import { Icon } from 'semantic-ui-react';
import {FormattedMessage} from 'react-intl';
import Utils from '../Common/Utils.js';


class TemperatureDisplay extends Component {

    display_value(){

        let unit = ""
        if (this.props.temperatureDisplay.temperature !== "-"){
            unit = "°C"
        }

        return(
            <Row style={{ flex:1, flexDirection:'row', alignItems:'center', justifyContent:'center', paddingTop:"5%"}}>
                <Col id="thermometer-icon">
                    <Icon name="thermometer half" size='huge' color={Utils.getConvertedColor(this.props.temperatureDisplay.color)}/>
                </Col>
                <Col>
                    {( !(this.props.DeviceSerialNumber.includes('-')) && !(this.props.maxTemperatureLast3h.temperature === "-") ) ?
                        <Row id="row-max3h-style">
                               <FormattedMessage id="tempMax.name" defaultMessage="max. 3h" /><div style={{paddingLeft: '0.5em', color: this.props.maxTemperatureLast3h.color}}>{this.props.maxTemperatureLast3h.temperature}</div>
                        </Row>
                        :
                        null
                    }
                    <Row>
                        <div>
                            <span id="row-measure-style" style={{color: this.props.temperatureDisplay.color}}>{this.props.temperatureDisplay.temperature}</span>
                            <span id="row-unit-style" style={{color: this.props.temperatureDisplay.color}}>{unit}</span>                        
                        </div>                    
                    </Row>                    
                </Col>
            </Row>
        )
    }


    //Display render
   	render(){

        return (
            <div id="col-temperature">
                {(this.props.alert) 
                    ?
                        <Col style={{backgroundColor: "yellow"}}>
                            {this.display_value()}
                        </Col>
                    :
                        <Col>
                            {this.display_value()}
                        </Col>
                }
            </div>
        );
   	}
}
export default (TemperatureDisplay);